import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import { Route, BrowserRouter as Router } from 'react-router-dom';

import { Dashboard } from '~/app/routes/Dashboard';
import AccountControls from '~/app/routes/account-controls';
import AggregatePage, { AggregateRoles } from '~/app/routes/aggregate-page';
import ExposePage, { SecrecyRoles } from '~/app/routes/expose-page';
import ImportStepper from '~/app/routes/import-stepper';
import ImportsPage, { ImportRoles } from '~/app/routes/imports-page';
import LoginForm from '~/app/routes/login-form';
import NavDrawer from '~/app/routes/nav-drawer';
import PasswordReset from '~/app/routes/password-reset';
import UserDetailPage from '~/app/routes/user-detail-page';
import UserListPage, { UserAdminRoles } from '~/app/routes/user-list-page';
import { VersionHandlerRoles, default as VersionHandlingPage } from '~/app/routes/version-handling-page';
import AuthPath from '~/components/auth-path';
import Topbar from '~/components/top-bar';
import * as AuthService from '~/services/authentication';
import { Dimensions, AcceptableRoles as NewDimensionFormRoles } from './routes/dimensions';
import { default as ExportsPage, AcceptableRoles as ExportsPageRoles } from './routes/exports-page';
import { default as ViewPage } from './routes/view-page';
import AdminPage from '~/app/routes/AdminPage';

export const AppRouter = () => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  useEffect(() => {
    const subscription = AuthService.getUserObs().subscribe((user) => {
      if (!user) {
        setDrawerOpen(false);
      }
    });
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const handleDrawerToggle = (open: boolean) => {
    setDrawerOpen(open);
  };

  const navMenuData = {
    items: [
      { text: 'Hem', route: '/', acceptableRoles: [] },
      {
        text: 'Administrera koder',
        route: '/dimensions',
        acceptableRoles: NewDimensionFormRoles,
      },
      {
        text: 'Aggregat',
        route: '/aggregates',
        acceptableRoles: AggregateRoles,
      },
      { text: 'Importer', route: '/imports', acceptableRoles: ImportRoles },
      { text: 'Granska', route: '/view', acceptableRoles: ExportsPageRoles },
      {
        text: 'Avancerad granskning',
        route: '/exposeview',
        acceptableRoles: SecrecyRoles,
      },
      {
        text: 'Exporter',
        route: '/exports',
        acceptableRoles: ExportsPageRoles,
      },
      'divider',
      {
        text: 'Versionshantering',
        route: '/versions',
        acceptableRoles: VersionHandlerRoles,
      },
      'divider',
      {
        text: 'Användarhantering',
        route: '/users',
        acceptableRoles: UserAdminRoles,
      },
      'divider',
      { text: 'Admin', route: '/admin', acceptableRoles: UserAdminRoles },
      'divider',
      { text: 'Mitt konto', route: '/account', acceptableRoles: [] },
    ],
  };

  return (
    <Router>
      <Topbar title="TPS 3.0" onMenuClick={() => handleDrawerToggle(!drawerOpen)} drawerOpen={drawerOpen} />
      <NavDrawer data={navMenuData} drawerOpen={drawerOpen} closeDrawer={() => handleDrawerToggle(false)} />
      <Grid container justifyContent="center">
        <AuthPath exact path="/dimensions" roles={NewDimensionFormRoles} component={Dimensions} />
        <AuthPath exact path="/exports/:id?" roles={ExportsPageRoles} component={ExportsPage} />
        <AuthPath exact path="/view" roles={ExportsPageRoles} component={ViewPage} />
        <AuthPath exact path="/exposeview" roles={SecrecyRoles} component={ExposePage} />
        <AuthPath exact path="/aggregates" roles={AggregateRoles} component={AggregatePage} />
        <AuthPath exact path="/imports/:id?" roles={ImportRoles} component={ImportsPage} />
        <AuthPath exact path="/import" roles={ImportRoles} component={ImportStepper} />
        <AuthPath exact path="/versions" roles={VersionHandlerRoles} component={VersionHandlingPage} />
        <AuthPath exact path="/users" roles={UserAdminRoles} component={UserListPage} />
        <AuthPath exact path="/users/:id" roles={UserAdminRoles} component={UserDetailPage} />
        <AuthPath exact path="/user/new" roles={UserAdminRoles} component={UserDetailPage} />
        <AuthPath exact path="/admin" roles={UserAdminRoles} component={AdminPage} />
        <AuthPath exact path="/account" roles={[]} component={AccountControls} />
        <AuthPath exact path="/" roles={[]} component={Dashboard} />
        <Route exact path="/login" component={LoginForm} />
        <Route exact path="/resetpassword" component={PasswordReset} />
      </Grid>
    </Router>
  );
};
